/**
 * Created by rak on 1/15/2016.
 */

'use strict';

angular.module('betosyswebapp').service('commonTrackService', function (serverBaseUrl, crudService, $q, AuthenticationService, base64, $rootScope, $window, $http, languageService, $timeout, $filter, localStorageService, $translate, dataContainerService, $uibModal, errorHandlingService, widgetSettingsCreatorService, dashboardService, localStoragePrefix) {


  var gtsServerSettings = {};
  var gtsDatePickerSettings = {};
  var loginID = '';
  var mainUrlDetails = '';
  var _lastLocationWidgetData = {};
  var _driverDashboardWidgetData = {};
  var _lastSelectedGroup = {};
  var _summaryCheckColumn = [];
  var that = this;
  var _dateRangePickerInitializedDate = null;
  this.dateRange = {
    LONG: 'LONG',
    MID: 'MID',
    SHORT: 'SHORT'
  };

  var driverMessageProperties = {
    driverMessageList: [],
    unreadMessages: 0,
    _tmpRefreshCheck: undefined
  };
  var notificationProperties = {
    notificationList: [],
    unreadNotification: 0
  };

  var accountSettings = {
    speedUnits: null,
    distanceUnits: null,
    volumeUnits: null,
    pressureUnits: null,
    economyUnits: null,
    temperatureUnits: null,
    timeZone: '',
    currencyUnits: null
  };
  var userSettings = {
    preferredDeviceID: null,
    authorizedGroupId: null,
    gridsSetting: {},
    SideBarStatus: {
      isCollapsed: true
    }
  };
  var gerneralSettings = {
    login: {
      accountID: ''
    }
  };

  this.initAuthdata = function () {
    loginID = AuthenticationService.GetLoginID();
    if (mainUrlDetails !== '') {
      mainUrlDetails = '';
    }
    mainUrlDetails = '?account=' + loginID.Account + '&faout=' + encodeURIComponent($rootScope.globals.currentUser.authdata);

  };

  this.getFleetServerDetails = function () {
    if (Object.getOwnPropertyNames(gtsServerSettings).length > 0) {
      var deferred = $q.defer();
      deferred.resolve(gtsServerSettings);
      return deferred.promise;
    } else {
      return this.setFleetServerDetails().then(function () {
        return gtsServerSettings;
      });
    }
  };

  this.getDatePickerDetails = function () {
    if (Object.getOwnPropertyNames(gtsDatePickerSettings).length > 0) {
      var deferred = $q.defer();
      deferred.resolve(gtsDatePickerSettings);
      return deferred.promise;
    } else {
      return this.setDatePickerDetails().then(function () {
        return gtsDatePickerSettings;
      });
    }
  };

  // SCL-1340
  // this.getTeletaleGroupComboList = function(isUserSettingsApplied, isWithAll){

  //   var telltaleGroupList = [
  //     {
  //       telltaleID : 'info',
  //       description : 'Info'
  //     },
  //     {
  //       telltaleID : 'yellow',
  //       description : 'Yellow'
  //     },
  //     {
  //       telltaleID : 'red',
  //       description : 'Red'
  //     },
  //   ];

  //   // return crudService.get('overview/devicegroup').then(function (telltaleGroupList) {
  //     if (isUserSettingsApplied) {
  //       var _authorisedGroup = userSettings.authorizedGroupId;
  //       var _tmpSource = [];
  //       if (_authorisedGroup !== null) {
  //         for (var i = 0; i < telltaleGroupList.length; i++) {
  //           if (telltaleGroupList[i].groupID === _authorisedGroup) {
  //             _tmpSource[0] = telltaleGroupList[i];
  //             break;
  //           }
  //         }
  //       }
  //       telltaleGroupList = _tmpSource.length > 0 ? _tmpSource : telltaleGroupList;
  //     }
  //     if (isWithAll) {
  //       if (telltaleGroupList.length > 0) {
  //         if (telltaleGroupList[0].telltaleID !== 'all') {
  //           telltaleGroupList.unshift({
  //             description: $translate.instant('additionalTranslation.comboboxOptionALL'),
  //             telltaleID: 'all'
  //           });
  //         }
  //       }
  //     }
  //     return $q.resolve(telltaleGroupList);

  //   // });
  // };


  this.getVehicleGroupComboList = function () {

    // includeGroupOptionAll is by default true , if user authorized to see all the groups then the server will return
    // 'all' group as part of response , description for 'all' must be added manually after the response
    return crudService.get('overview/devicegroup?includeGroupOptionAll=true').then(function (vechileGroupList) {
      if (vechileGroupList.length > 0) {

        if (vechileGroupList[0].groupID === 'all') { // server sends option all without translation
          vechileGroupList[0].description = $translate.instant('additionalTranslation.comboboxOptionALL');
        }

      }

      return vechileGroupList;

    });
  };


  this.setFleetServerDetails = function () {
    return crudService.get('overview/fleetserver').then(function (getsServerDetails) {
      gtsServerSettings = getsServerDetails;
      return gtsServerSettings;
    });
  };

  this.setDatePickerDetails = function () {
    return crudService.get('viewsettings/daterangepickersettings').then(function (getsPickerDetails) {
      gtsDatePickerSettings = getsPickerDetails;
      return gtsDatePickerSettings;
    });
  };

  this.updateGtsAccountSettings = function () {
    return crudService.get('user/accountsettings').then(function (gtsAccountSettings) {

      if(!gtsAccountSettings)
      {
        gtsAccountSettings = {};
      }
      accountSettings.speedUnits = gtsAccountSettings.speedUnits !== undefined ? gtsAccountSettings.speedUnits : null;
      accountSettings.distanceUnits = gtsAccountSettings.distanceUnits !== undefined ? gtsAccountSettings.distanceUnits : null;
      accountSettings.volumeUnits = gtsAccountSettings.volumeUnits !== undefined ? gtsAccountSettings.volumeUnits : null;
      accountSettings.pressureUnits = gtsAccountSettings.pressureUnits !== undefined ? gtsAccountSettings.pressureUnits : null;
      accountSettings.economyUnits = gtsAccountSettings.economyUnits !== undefined ? gtsAccountSettings.economyUnits : null;
      accountSettings.temperatureUnits = gtsAccountSettings.temperatureUnits !== undefined ? gtsAccountSettings.temperatureUnits : null;
      accountSettings.timeZone = gtsAccountSettings.timeZone !== undefined ? gtsAccountSettings.timeZone : '';
      accountSettings.currencyUnits = gtsAccountSettings.currencyUnits !== undefined ? gtsAccountSettings.currencyUnits : null;
      loginID = AuthenticationService.GetLoginID();
      if (loginID) {
        localStorageService.set('accountSettings.' + loginID.Account + '.' + loginID.username, accountSettings);
      }
      return accountSettings;
    });
  };

  /**
   * if isLatest set true will get the latest settings from server , ( have problem due to local storage instant changes under the
   * Track Application not reflected here in betotrack.
   *
   * @param isLatest
   */
  this.getGtsAccountSettings = function (isLatest) {
    loginID = AuthenticationService.GetLoginID();
    var localStorageAccountSettings = localStorageService.get('accountSettings.' + loginID.Account + '.' + loginID.username);
    if (!isLatest && localStorageAccountSettings) {
      accountSettings = localStorageAccountSettings;
      var deferred = $q.defer();
      deferred.resolve(accountSettings);
      return deferred.promise;
    } else {
      return that.updateGtsAccountSettings();
    }
  };

  this.updateGtsUserSettings = function () {
    return crudService.get('user/usersettings').then(function (gtsUserSettings) {
      userSettings.authorizedGroupId = gtsUserSettings !== undefined ? gtsUserSettings.authorizedGroupId : null;
      userSettings.preferredDeviceID = gtsUserSettings !== undefined ? gtsUserSettings.preferredDeviceID : null;
      loginID = AuthenticationService.GetLoginID();
      var localstorageSettings = that.getGtsLocalStorageSettings() || {};
      userSettings.gridsSetting = localstorageSettings.gridsSetting || {};
      localStorageService.set('userSettings.' + loginID.Account + '.' + loginID.username, userSettings);
      return userSettings;
    });
  };
  this.getGtsUserSettings = function (isLatest) {
    loginID = AuthenticationService.GetLoginID();
    var localStorageUserSettings = localStorageService.get('userSettings.' + loginID.Account + '.' + loginID.username);
    if (!isLatest && localStorageUserSettings) {
      userSettings = localStorageUserSettings;
      var deferred = $q.defer();
      deferred.resolve(userSettings);
      return deferred.promise;
    } else {
      return that.updateGtsUserSettings();
    }
  };
  this.getGtsLocalStorageSettings = function () {
    if (AuthenticationService.GetLoginID()) {
      loginID = AuthenticationService.GetLoginID();
      return localStorageService.get('userSettings.' + loginID.Account + '.' + loginID.username);
    }
    return null;
  };

  this.saveGtsUserSettings = function (userSettings) {
    loginID = AuthenticationService.GetLoginID();
    localStorageService.set('userSettings.' + loginID.Account + '.' + loginID.username, userSettings);
  };
  this.getDeviceComboList = function (isWithAll) {
    return crudService.get('overview/devicelist').then(function (devices) {

      devices = devices.sort(function (a, b) {
        return _sortCompare(a.description, b.description, true);
      });

      if (isWithAll) {
        if (devices.length > 0) {
          if (devices[0].deviceID !== 'all') {
            devices.unshift({
              description: $translate.instant('additionalTranslation.comboboxOptionALL'),
              deviceID: 'all'
            });
          }
        }
      }
      return devices;
    });
  };

  this._functionUpdateMapUrl = function (serverUrl, value, frameId) {

    var mapURL = serverUrl + mainUrlDetails + value + '&locale=' + languageService.getLanguageSettings().language;
    if (frameId) {
      mapURL += '&frameId=' + frameId;
    }
    return mapURL + '&required_session=false';
  };


  this.getSelectRowIndexByCache = function (rows) {
    var selectedIndex = -1;
    var loginid = AuthenticationService.GetLoginID();
    var lastCacheMap = localStorageService.get('selected_vehicle.' + loginid.Account + '.' + loginid.username);
    if (!rows) {
      return selectedIndex;
    }
    if (rows.length !== 0) {
      selectedIndex = 0;
    }
    if (!lastCacheMap) {
      return selectedIndex;
    }
    for (var j = 0; j < rows.length; j++) {
      if ((rows[j].deviceid) !== undefined && (rows[j].deviceid === lastCacheMap.deviceid)) {

        if (rows[j].dataindex) {
          return rows[j].dataindex;
        }
        return j;
      }
    }
    //console.log('seelcted row index cache ' + selectedIndex);
    return selectedIndex;
  };

  // bug 89759
  this.getLocalization = function () {
    var translationObj = {
      gotopagestring: $translate.instant('listView.common.localization.gotopagestring'),
      showrowsstring: $translate.instant('listView.common.localization.showrowsstring'),
      rangestring: $translate.instant('listView.common.localization.rangestring'),
      nextbuttonstring: $translate.instant('listView.common.localization.nextbuttonstring'),
      previousbuttonstring: $translate.instant('listView.common.localization.previousbuttonstring'),
      sortascendingstring: $translate.instant('listView.common.localization.sortascendingstring'),
      sortdescendingstring: $translate.instant('listView.common.localization.sortdescendingstring'),
      sortremovestring: $translate.instant('listView.common.localization.sortremovestring'),
      filterselectstring: $translate.instant('listView.common.localization.filterselectstring'),
      filterselectallstring: $translate.instant('listView.common.localization.filterselectallstring'),
      loadtext: $translate.instant('listView.common.localization.loadtext'),
      emptydatastring: $translate.instant('listView.common.localization.emptydatastring'),
      validationstring: $translate.instant('listView.common.localization.validationstring')
    };
    return translationObj;
  };


  this.getGridSettings = function (modelName, customGridProperties, rowIndex, additionalProperties) {
    var currentScope = this;
    var gridName = that.getOverviewGridPrefix() + modelName + 'List';


    var jqxGridList = $window.localStorage['jqxGrid' + that.getOverviewGridPrefix() + modelName + 'List'];

    currentScope.gridSettingId = '';
    currentScope.gridStorage = null;
    currentScope.localStorageRowIndex = 0;
    currentScope.gridSettingId = that.getOverviewGridPrefix() + modelName + 'List';
    currentScope.userSettings = that.getGtsLocalStorageSettings();
    if (jqxGridList !== undefined) {
      currentScope.gridStorage = JSON.parse(jqxGridList);
      currentScope.localStorageRowIndex = currentScope.gridStorage ? currentScope.gridStorage.selectedrowindex : 0;
      currentScope.gridStorage.selectedrowindex = -1;// row select comes t
      currentScope.gridStorage.height = customGridProperties && customGridProperties.height ? customGridProperties.height : currentScope.gridStorage.height;


      if (customGridProperties.columns) {
        for (var i = 0; i < customGridProperties.columns.length; i++) {
          if (!currentScope.gridStorage.columns[customGridProperties.columns[i].datafield]) {
            continue;
          }

          if (currentScope.userSettings && currentScope.userSettings.gridsSetting[currentScope.gridSettingId] && currentScope.userSettings.gridsSetting[currentScope.gridSettingId].frozenColumns) {
            var temp;
            for (var pinnedIndex in currentScope.userSettings.gridsSetting[currentScope.gridSettingId].frozenColumns) {
              temp = currentScope.userSettings.gridsSetting[currentScope.gridSettingId].columnsOrders[pinnedIndex].name;
              if (customGridProperties.columns[i].datafield === temp) {
                currentScope.gridStorage.columns[customGridProperties.columns[i].datafield].pinned = true;
                break;
              }
              // $('#' + gridName).jqxGrid('pincolumn', temp);
            }
          }

          currentScope.gridStorage.columns[customGridProperties.columns[i].datafield].text = customGridProperties.columns[i].text;
          currentScope.gridStorage.columns[customGridProperties.columns[i].datafield].hidden = customGridProperties.columns[i].hidden;
        }
      }

      if (currentScope.userSettings && currentScope.userSettings.gridsSetting[currentScope.gridSettingId] && currentScope.userSettings.gridsSetting[currentScope.gridSettingId].columnsOrders) {
        //set column order
        for (var showIndex in currentScope.userSettings.gridsSetting[currentScope.gridSettingId].columnsOrders) {

          var fieldName = currentScope.userSettings.gridsSetting[currentScope.gridSettingId].columnsOrders[showIndex].name;
          if (currentScope.gridStorage.columns[fieldName]) {
            currentScope.gridStorage.columns[fieldName].index = parseInt(showIndex);
          }
        }
      }

      //console.log(currentScope);
      $window.localStorage.setItem('jqxGrid' + that.getOverviewGridPrefix() + modelName + 'List', JSON.stringify(currentScope.gridStorage));
    }



    var settings = {
      source: [],
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
      width: '100%',
      height: 300,
      columnsheight: 45,
      rowsheight: that.getJqxGridRowHeight(),
      columnsresize: true,
      columnsreorder: true,
      showfilterrow: true,
      filterable: true,
      altrows: true,
      autoheight: false,
      autoloadstate: true,
      autosavestate: true,
      enabletooltips: true,
      pageable: true,
      editable: false,
      pagesizeoptions: ['5', '10', '15', '25'],
      pagesize: 5,
      // bug 89759
      localization: that.getLocalization(),
      ready: function () {
        //console.log( gridName + ' Grid ready() start At : '+ moment().format('HH:mm:ss.SSS'));
        if ($('#' + gridName).length !== 0) {
          var rows = $('#' + gridName).jqxGrid('getrows');

          rowIndex = that.getSelectRowIndexByCache(rows);
          if (currentScope.gridStorage) {
            currentScope.gridStorage.selectedrowindex = rowIndex >= 0 ? rowIndex : currentScope.gridStorage.selectedrowindex;

          } else if (rowIndex > 0) {
            currentScope.localStorageRowIndex = rowIndex; // override localstorage index with cached index
          }
          try {
            // non sort grid ( sorted grid do row selection after sort
            if ((currentScope.gridStorage && !currentScope.gridStorage.sortcolumn) || !currentScope.gridStorage) {
              var rowToSelect = currentScope.gridStorage && currentScope.gridStorage.selectedrowindex !== undefined ? currentScope.gridStorage.selectedrowindex : currentScope.localStorageRowIndex;
              $timeout(function () {
                //  console.log('Reday row select ' + rowToSelect);
                $('#' + gridName).jqxGrid('selectrow', rowToSelect);
                //console.log( gridName + ' ready()->row select  At : '+ moment().format('HH:mm:ss.SSS'));
              }, 0);
            }

          } catch (error) {
            console.log(error);
          }


          var filterinfo = $('#' + gridName).jqxGrid('getfilterinformation');
          if (filterinfo && filterinfo.length === 0 && $('#' + gridName + 'FilterBtn').length !== 0) {
            $('#' + gridName + 'FilterBtn').jqxButton({
              disabled: true
            });
          }

          // Grid listeners
          $('#' + gridName).on('filter', function (event) {
            if (event.args.filters.length > 0) {
              $('#' + gridName + 'FilterBtn').jqxButton({
                disabled: false
              });
            } else {
              $('#' + gridName + 'FilterBtn').jqxButton({
                disabled: true
              });
            }
          });

          if (additionalProperties && additionalProperties.isDynamicGrid) {
            var gridSettingId = additionalProperties.dynamicModuleName + '-' + that.getOverviewGridPrefix() + modelName + 'List';
          }

          $('#' + gridName).on('columnreordered', function (event) {
            var userSettings = that.getUserSettings();
            userSettings = widgetSettingsCreatorService.rebuildDragColumnsOrder(userSettings, gridSettingId, event.args);
            if (userSettings) {
              that.saveUserSettings(userSettings);
            }
          });

        }
        //console.log(gridName +  ' Grid ready() Finished At : '+ moment().format('HH:mm:ss.SSS'));
        // $('#' + gridName).on('bindingcomplete', function () {
        //   //console.log( gridName + ' Binding is completed/ Rendering Start  At :'+ moment(new Date()).format('HH:mm:ss.SSS'));
        // });

        $('#' + gridName).on('sort', function () {
          var selectedRowIndex = that.getSelectRowIndexByCache($('#' + gridName).jqxGrid('getrows'));

          //BUg 108544#c6
          // When grid is sorted and filtered ( selection of row needs some , else the 'selectrow' is not considered.)
          setTimeout(function () {
            $('#' + gridName).jqxGrid('selectrow', selectedRowIndex);
          }, 0);

        });

        // SCL-4719 : Auto resize column for smaller devices which helps better reading of column header and values.
        setTimeout(() => {
          switch (that.getViewPortName()) {
            case 'XS':
            case 'SM':
              $('#' + gridName).jqxGrid('autoresizecolumns');
          }
        }, 0);
      },
      sortable: true,
      columns: []
    };

    if (customGridProperties) {
      settings = _.extend(settings, customGridProperties);
    }
    settings.showtoolbar = true;
    settings.rendertoolbar = function (statusbar) {
      var showfilterrow = settings.showfilterrow;
      showfilterrow = showfilterrow === undefined ? true : showfilterrow;
      var container = $('<div style="overflow: hidden; position: relative; margin: 5px;"></div>');
      var _coloringBtnBtnName = gridName + 'ColouringBtn';
      var addButton = $('<div id="' + _coloringBtnBtnName + '" style="float: left;" title="' + $translate.instant('filter.settings') + '"><span class="glyphicon glyphicon-wrench"></span></div>');
      var _filterBtnName = gridName + 'FilterBtn';
      var showFilterRowButton = $('<div style="float: left; margin-left:5px;" id="' + _filterBtnName + '" title="' + $translate.instant('filter.clearFilter') + '"><span class="glyphicon glyphicon-filter glyphicon-remove-circle" ></span></div>');
      var _resizeBtnName = gridName + 'ResizeBtn';
      var showResizeRowButton = $('<div style="float: left; margin-left:5px;" id="' + _resizeBtnName + '" title="' + $translate.instant('filter.resize') + '"><span class="glyphicon glyphicon-resize-horizontal" ></span></div>');

      container.append(addButton);
      if (showfilterrow) {
        container.append(showFilterRowButton);
        container.append(showResizeRowButton);
        showFilterRowButton.jqxButton({});
        showResizeRowButton.jqxButton({});

      }
      statusbar.append(container);
      addButton.jqxButton({});
      $('#' + _coloringBtnBtnName).unbind('click');
      $('#' + _coloringBtnBtnName).bind('click', function () {
        var modelName = additionalProperties && additionalProperties.isDynamicGrid ? additionalProperties.dynamicModuleName : modelName;
        widgetSettingsCreatorService.openGridSettingDialog(modelName, gridName, that, {
          columns: settings.columns,
          additionalCustomProperties: additionalProperties || {}
        });
      });

      if (gridName) {
        showFilterRowButton.click(function () {
          $('#' + gridName).jqxGrid('clearfilters');
          $(this).jqxButton({
            disabled: true
          });
          $(this).removeClass('jqx-fill-state-hover');
        });
        showResizeRowButton.click(function () {
          $('#' + gridName).jqxGrid('autoresizecolumns');
        });
      }
    };
    //console.log( gridName +' Settings created At : '+ moment().format('HH:mm:ss.SSS'));
    return settings;
  };

  this.createColumn = function (columnProperty, transalationMap, comboBoxAdaptor, gridTransalationModuleName) {
    var headerName = columnProperty.name;
    var obj = {};
    if (Object.keys(transalationMap).length === 0 && transalationMap) {
      obj.text = $translate.instant('listView.' + gridTransalationModuleName.moduleName + '.headers.' + headerName);
    } else {
      obj.text = (transalationMap !== undefined && transalationMap[columnProperty.name] !== undefined) ? transalationMap[columnProperty.name] : columnProperty.name;
    }

    //default styling

    if (!columnProperty.isCheckBox && !columnProperty.isProgressBar) {
      obj.cellsrenderer = function (index, datafield, value) {
        return '<span class="dataCell">' + value + '</span>';
      };
    }

    if (columnProperty.type === 'STRING') {
      obj.type = 'string';
    } else if (columnProperty.type === 'INT') {
      obj.type = 'number';
    } else if (columnProperty.type === 'TIMESTAMP') {
      obj.cellsrenderer = function (index, datafield, value) {
        if (!isNaN(value)) {
          return '<span class="dataCell">' + $filter('date')(new Date(value * 1000), 'dd/MM/yyyy HH:mm:ss') + '</span>';
        }
        return '<div>'+value+'</div>';
      };
      obj.cellsalign = 'right';
      obj.type = 'datetime';
    } else if (columnProperty.type === 'DATE') {
      obj.type = 'date';
      obj.cellsrenderer = function (index, datafield, value) {
        if (!value.match(/^\d{2}[./.]\d{2}[./.]\d{4}$/)) {// check if the value in the format of dd.MM.YYYY or dd/MM/YYYY
          return '<span class="dataCell">' + $filter('date')(value, 'dd/MM/yyyy') + '</span>';
        }
        return '<div>'+value+'</div>'; // already a date value with dd.MM.YYYY

      };
    }
    else if (columnProperty.type === 'FLOAT') {
      obj.type = 'float';
      obj.cellsrenderer = function (index, datafield, value) {
        var LocaleIdentification = 1.01;
        var displayValue;
        if (columnProperty.floatingDecimalPoint) {
          displayValue = value.toFixed(Number(columnProperty.floatingDecimalPoint));
        } else {
          displayValue = value;
        }
        if (LocaleIdentification.toLocaleString().indexOf('.') > -1) {
          return '<span class="dataCell">' + displayValue + '</span>';
        } else {
          return '<span class="dataCell">' + displayValue.toString().replace('.', ',') + '</span>';
        }
      };
    } else if (columnProperty.type === 'BUTTON') {
      obj.cellsrenderer = function () {

        return '<div  style="margin: 4px; float: left;" ><input type="button" onClick="buttonclick(event)" class="gridButton btn-info" id="btn"  value="' + columnProperty.name + '"/></div>';
      };
    }


    if (columnProperty.isProgressBar) {
      //obj.columntype = 'progressbar';
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        if(value < 0) {
          return '<progress class="jqx-progress-negative" max="'+Math.abs(rowdata.drumrotationmax)+'" value="'+Math.abs(value)+'"></progress>';
        } else {
          return '<progress class="jqx-progress-positive" max="'+Math.abs(rowdata.drumrotationmax)+'" value="'+Math.abs(value)+'"></progress>';
        }
      };
    }
    if (columnProperty.isComboBox) {
      obj.displayfield = obj.text;
      obj.columntype = 'combobox';
      obj.createeditor = function (row, column, editor) {
        editor.jqxComboBox({
          source: comboBoxAdaptor,
          autoDropDownHeight: false,
          displayMember: comboBoxAdaptor._source.datafields[0].name,
          valueMember: comboBoxAdaptor._source.datafields[1].name
        });
      };
    }
    if (columnProperty.isHidden) {
      obj.hidden = 'true';
    }

    if (columnProperty.hasBgColor && columnProperty.hasColor) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        //return defaultvalue.split('">')[0] + 'color:' + rowdata[columnProperty.name + 'Color'] + ';background-color:' + rowdata[columnProperty.name + 'BgColor'] + ';" class="dataCell" >' + value + '</div>';
        return '<div class="dataCell" style="color:' + rowdata[columnProperty.name + 'Color'] + '; background-color:' + rowdata[columnProperty.name + 'BgColor'] + ';">' + value + '</div>';
      };
    } else if (columnProperty.hasColor) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        return '<div class="dataCell" style="color:' + rowdata[columnProperty.name + 'Color'] + ';">' + value + '</div>';
      };
    } else if (columnProperty.hasBgColor) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        //console.log(defaultvalue);
        return '<div class="dataCell" style="background-color:' + rowdata[columnProperty.name + 'BgColor'] + ';">' + value + '</div>';
      };
    } else if (columnProperty.hasFontStyle) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        //console.log(defaultvalue);
        return '<div class="dataCell" style="font-style:' + rowdata[columnProperty.name + 'FontStyle'] + ';">' + value + '</div>';
      };
    }
    // Icon Logic
    if (columnProperty.hasIcon && columnProperty.hasIcon === true) {
      obj.cellsrenderer = function (index, datafield, value, defaultvalue, column, rowdata) {
        var style = 'height: 100%;';
        var icon = rowdata[columnProperty.name + 'Icon'];
        // display type options ['icon_only','both','none' (no icon)]
        var displayType = rowdata[columnProperty.name + 'IconDisplayType'];
        var tempValue = value; // Didnt want to ovewrite value
        var additionClasses = '';

        if (icon === 'NONE') {
          return;
        }

        if (!icon) {
          additionClasses = 'dataCell';
        } else {
          additionClasses += ' dataIconCell';
        }
        if (displayType === 'ICON_ONLY') {
          // Icon only - remove tempvalue
          // TODO: look at the possibility of using hover to display value
          tempValue = '';
          additionClasses += ' text-center';
        }

        if (displayType === 'ICON_ONLY' || displayType === 'BOTH' || displayType === 'COMBINATION') {
          // include icon tag
          var iconHtml = '';
          var iconBackground = '';
          if (icon.indexOf(',') > -1 || columnProperty.isMultiIconColumn === true) {
            additionClasses += ' dataIconCell';
            var iconList = icon.split(',');

            for (var j = 0; j < iconList.length; j++) {

              iconBackground = '';
              if (iconList[j] !== '' && iconList[j] !== ' ') {
                iconBackground = ' dsa-icon-background';
              }

              iconHtml += '<div class="multi-icon-dsa ' + iconList[j] + iconBackground + '"> </div>';
            }

          } else {
            // iconHtml += '<i class="' + icon + '"></i> &nbsp';
            if (icon !== '' && icon !== ' ') {
              iconBackground = ' dsa-icon-background';
            }

            iconHtml += '<div class="multi-icon-dsa ' + icon + iconBackground + '"> </div>';
          }

          if (displayType === 'COMBINATION') {
            tempValue = iconHtml;
          } else {
            tempValue = iconHtml + ' &nbsp' + tempValue;
          }
        }

        if (columnProperty.hasBgColor) {
          style += 'background-color:' + rowdata[columnProperty.name + 'BgColor'] + ';';
        }

        if (columnProperty.hasColor) {
          style += 'color:' + rowdata[columnProperty.name + 'Color'] + '';
        }

        if (columnProperty.hasFontStyle) {
          style += ';font-style:' + rowdata[columnProperty.name + 'FontStyle'] + '';
        }

        if (displayType === 'COMBINATION') {
          //style the divs
          var newDefault = $(defaultvalue);
          newDefault[0].classList = newDefault[0].classList + ' text-with-icon-textdiv';
          var newTemp = $(tempValue);
          newTemp[0].classList = newTemp[0].classList + ' text-with-icon-icondiv';
          return newDefault[0].outerHTML.concat(newTemp[0].outerHTML);
        } else {
          return '<div class="' + additionClasses + '" style="' + style + '">' + tempValue + '</div>';
        }
      };
    }
    if (columnProperty.isFormattableTelephoneField) {
      obj.cellsrenderer = function (row, column, value, defaultHtml) {
        if (value && defaultHtml) {
          return '<input class="telephnoe-overview-btn"  value = "' + value + '" > </input > ';
        }
      };
    }

    obj.datafield = headerName;
    obj.width = columnProperty.width;

    if (columnProperty.isCheckBox) {
      obj.columntype = 'checkbox';
      obj.type = 'bool';
    }

    if (columnProperty.isProgressBar) {
      //obj.columntype = 'progressbar';
      obj.type = 'number';
    }

    if (columnProperty.isReadOnly) {
      obj.editable = false;
    }

    // SCL-1340
    if (columnProperty.customFilterCheckBoxList) {
      obj.filtertype = 'checkedlist';
      obj.filteritems = columnProperty.customCheckBoxFilterOptions;
      for (var fi = 0; fi < obj.filteritems.length; fi++) {
        obj.filteritems[fi].value = $translate.instant('listView.' + gridTransalationModuleName.moduleName + '.headerColumnfilters.' + headerName + '.' + obj.filteritems[fi].value);
        obj.filteritems[fi].text = obj.filteritems[fi].value;
      }

      // loop through items and provide teansalations
      //$translate.instant('listView.' + gridTransalationModuleName.moduleName + '.$translate.instant('listView.' + gridTransalationModuleName.moduleName + '.headers.filters.' + headerName+".loppedfiltervalue").' + headerName)
      obj.createfilterwidget = function (column, columnElement, widget) {
        if (!widget.hasClass(gridSettingId + '-' + headerName + '-custom-filter')) {
          widget.jqxDropDownList({
            displayMember: 'value', valueMember: 'text',
            dropDownHeight: 500, dropDownWidth: '450px'
          });
          widget.on('close', function () {


            if ($('#wrapper' + gridSettingId + ' .jqx-grid-load').is(':visible')) {
              return;
            }
            if (this._selectionChanged) {
              var checkedItems = widget.jqxDropDownList('getCheckedItems');

              setTimeout(function () {
                var filtergroup = new $.jqx.filter();
                var checkedIndexed = [];
                var gridName = '#' + gridSettingId;
                for (var i = 0; i < checkedItems.length; i++) {
                  // add checked values to the filter
                  // note: first one could be a select all option and filter will be added to check for that,
                  // but this wont filter any of the results
                  var filtervalue = checkedItems[i].value;// test
                  var filtercondition = 'contains';
                  var filter1 = filtergroup.createfilter('stringfilter', filtervalue, filtercondition);
                  filtergroup.addfilter(1, filter1);
                  checkedIndexed.push(checkedItems[i].index);
                }
                // add the filters.
                $(gridName).jqxGrid('addfilter', headerName, filtergroup);
                // apply the filters.
                // check again since 'addfilter' removes the filter by default
                setTimeout(function () {
                  for (var i = 0; i < checkedIndexed.length; i++) {
                    widget.jqxDropDownList('checkIndex', checkedIndexed[i]);
                  }
                }, 100);
                $(gridName).jqxGrid('applyfilters');
                //console.log('Custom filters applied');
              }, 0);

            }

          });

          // bug 90013
          setTimeout(function () {
            widget.jqxDropDownList('uncheckAll');
            var listitems = widget.jqxDropDownList('getItems');
            var filterInfo = $('#' + gridSettingId).jqxGrid('getfilterinformation');
            for (var j = 0; j < filterInfo.length; j++) {
              var filter = filterInfo[j];
              // grid has filters for that specific column
              if (filter.datafield === headerName) {
                var filterObjs = filter.filter.getfilters();
                // filter values being applied
                for (var q = 0; q < filterObjs.length; q++) {
                  // iterate through dropdown list to select filters again
                  for (var x = 0; x < listitems.length; x++) {
                    if (listitems[x].value === filterObjs[q].value) {
                      widget.jqxDropDownList('checkIndex', x);
                      break;
                    }
                  }
                }
              }
            }

          }, 0);

        }

      };
    }

    if (!columnProperty.isCheckBox) {
      obj.renderer = function (text) {
        return '<div style=" padding:4px; ">' + text.replace(/\\n/gm, '<br>') + '</div>';
      };
    }

    if (columnProperty.columnGroup) {
      obj.columngroup = columnProperty.columnGroup;
    }

    if (columnProperty.isSummaryCheck) {
      _summaryCheckColumn.push(columnProperty.name);
    }
    obj.cellclassname = this.cellClassName;


    var gridSettingId = that.getGridId (gridTransalationModuleName);

    // do viewport related column width setting / disabling if not defined
    switch (that.getViewPortName()) {
      case 'XS':
        obj = _setViewPortWidth(columnProperty.columnViewPortWidth || null, obj, 'widthXS', gridSettingId);
        break;
      case 'SM':
        obj = _setViewPortWidth(columnProperty.columnViewPortWidth || null, obj, 'widthSM', gridSettingId);
        break;
      case 'MD':
        obj = _setViewPortWidth(columnProperty.columnViewPortWidth || null, obj, 'widthMD', gridSettingId);
        break;
      case 'LG':
        obj = _setViewPortWidth(columnProperty.columnViewPortWidth || null, obj, 'widthLG', gridSettingId);
        break;
    }

    var userSettings = that.getGtsLocalStorageSettings();
    return widgetSettingsCreatorService.applyGridSettingToGrid(gridSettingId, userSettings, obj, headerName);
  };

  this.getGridId =  function(gridTransalationModuleName){
    var gridSettingId = gridTransalationModuleName && gridTransalationModuleName.moduleName ? gridTransalationModuleName.moduleName : '';
    gridSettingId = that.getOverviewGridPrefix() + gridSettingId + 'List';

    if (gridTransalationModuleName && gridTransalationModuleName.reportModel) {  //report grid
      gridSettingId = gridTransalationModuleName.moduleName + '-' + that.getOverviewGridPrefix() + gridTransalationModuleName.reportModel + 'List';
    } else {
      gridSettingId = gridTransalationModuleName && gridTransalationModuleName.moduleName ? gridTransalationModuleName.moduleName : '';
      gridSettingId = that.getOverviewGridPrefix() + gridSettingId + 'List';
    }
    return gridSettingId;

  };
  /**
   *
   * Used in the co ntext of createColumn() , to set width of specified view port or else if  width is empty make that column hidden.
   *
   * @param viewporWidth  - object which contains the view port Width values ( widthMD , widthLG .. etc )
   * @param columnOBJ -  column obj  which is filed in the createColumn()
   * @param viewPortWidthKey -  with key to get value from viewporWidth object .
   * @returns {columnOBJ}
   * @private
   */
  function _setViewPortWidth(viewporWidth, columnOBJ, viewPortWidthKey, gridSettingId) {
    var jqxGridList = $window.localStorage['jqxGrid' + gridSettingId];
    var gridStorage;


    if (viewporWidth && viewporWidth[viewPortWidthKey] !== null && viewporWidth[viewPortWidthKey] !== undefined) { // viewporWidth[viewPortWidthKey]  can be '' so if condition may fail NULL && undefined check is necessary
      if (jqxGridList) {
        gridStorage = JSON.parse(jqxGridList);
      }

      if (viewporWidth[viewPortWidthKey] !== '') {
        columnOBJ.width = viewporWidth[viewPortWidthKey];
        if (gridStorage) {
          // not already hidden by settings widget
          if (gridStorage.columns[columnOBJ.datafield] && gridStorage.columns[columnOBJ.datafield].hidden !== true) {
            gridStorage.columns[columnOBJ.datafield].hidden = false;
          }
        }

      } else {
        columnOBJ.hidden = 'true';
        if (gridStorage) {
          gridStorage.columns[columnOBJ.datafield].hidden = true;
        }
      }
      if (gridStorage) {
        $window.localStorage.setItem('jqxGrid' + gridSettingId, JSON.stringify(gridStorage));
      }

    }
    return columnOBJ;
  }

  this.cellClassName = function (row, column, value, data) {
    var result = false;
    for (var i = 0; i < _summaryCheckColumn.length; i++) {
      result = (result || data[_summaryCheckColumn[i]]);
      if (result) {
        break;
      }
    }
    if (!result && _summaryCheckColumn.length > 0) {
      return 'gridsummaryclass';
    }
  };


  this.createColumnGroups = function (groupList, gridName) {
    var _tmpArry = [];
    for (var i = 0; i < groupList.length; i++) {
      _tmpArry[i] = this.getColumnGroup(groupList[i], gridName);
    }
    return _tmpArry;
  };

  this.getColumnGroup = function (groupProperty, gridName) {
    var _tmpObj = {};
    _tmpObj.text = $translate.instant('listView.' + gridName + '.headers.' + groupProperty);
    _tmpObj.name = groupProperty;
    _tmpObj.align = 'center';
    return _tmpObj;
  };
  this.rebuildDataSource = function (columnPropertiesList, translationMap, dataSource) {
    for (var i = 0; i < columnPropertiesList.length; i++) {
      var columnProperty = columnPropertiesList[i];
      if (columnProperty.hasMultiValued) {
        var multiValueName = columnProperty.name;
        var multiValueStr = translationMap[multiValueName];
        var multiValueStrArray = multiValueStr.split(';');
        for (var j = 0; j < dataSource.length; j++) {
          var item = dataSource[j];
          var multiValueList = item[multiValueName];

          for (var k = 0; k < multiValueList.length; k++) {
            item[multiValueStrArray[k]] = multiValueList[k];
          }
        }
      }
    }
  };

  var parseMultiValueColumnProperty = function (columnPropertiesList, transalationMap, multiValueTranslationMap, multiValueColumnPropertiesList) {
    var multiValuedList = [];
    for (var j = 0; j < columnPropertiesList.length; j++) {
      var columnProperty = columnPropertiesList[j];
      if (columnProperty.hasMultiValued) {
        columnProperty.isHidden = true;
        multiValuedList.push(columnProperty);
      }
    }
    for (var m = 0; m < multiValuedList.length; m++) {
      var multiValueColumnProperty = multiValuedList[m];
      var multiValueStr = transalationMap[multiValueColumnProperty.name];
      if (multiValueStr) {
        var multiValueStrArray = multiValueStr.split(';');
        for (var n = 0; n < multiValueStrArray.length; n++) {
          var multiValue = multiValueStrArray[n];
          var multiValueColumnPropertyCopy = _.assign({}, multiValueColumnProperty);
          multiValueColumnPropertyCopy.name = multiValue;
          multiValueColumnPropertyCopy.isHidden = false;
          multiValueColumnPropertiesList.push(multiValueColumnPropertyCopy);
          multiValueTranslationMap[multiValue] = multiValue;
        }
      }
    }
  };


  this.getColumnProperties = function (columnPropertiesList, transalationMap, gridTransalationModuleName) {
    var multiValueTranslationMap = {};
    var multiValueColumnPropertiesList = [];
    parseMultiValueColumnProperty(columnPropertiesList, transalationMap, multiValueTranslationMap, multiValueColumnPropertiesList);
    var newColumnPropertiesList = columnPropertiesList.concat(multiValueColumnPropertiesList);
    var newTranslationMap = _.assign(transalationMap, multiValueTranslationMap);
    var column = [];
    _summaryCheckColumn = []; // clear, rebuild the check in below loop
    //var portName = that.getViewPortName();

    //var gridLocalStroage = $window.localStorage['jqxGrid' + that.getGridId (gridTransalationModuleName)];
    for (var k = 0; k < newColumnPropertiesList.length; k++) {
      column[k] = this.createColumn(newColumnPropertiesList[k], newTranslationMap, undefined, gridTransalationModuleName);

      // if(columnPropertiesList[k].isCheckBox){
      //   var checkBoxDataFields = {
      //     name: $scope['columns' + column[k]].datafield,
      //     type: 'bool'
      // };
      // }
      /* switch (portName) {
        case 'XS':
        case 'SM':
          if (k >= 14 &&  !gridLocalStroage) {
            column[k].hidden = true;
          }
      }*/
    }
    return _.sortBy(column, 'index');


  };


  var baseUrl = serverBaseUrl + '/';
  this.getOverviewListSettings = function (modelName) {
    var dataLoader = {
      load: function () {
        return $http({ url: baseUrl + 'viewsettings/' + modelName + '/overviewsetting', method: 'GET' });
      }
    };
    return dataContainerService.getData(modelName + 'OverviewListSettings', dataLoader, false);
  };

  /**
   *  this method will update the grid data using JQX bound data and call the sort method on JQX to keep the sorting after data refresh.
   *  while calling update bound data call sort , update bound data will remove the filter and sorting .
   * @param gridName
   */
  this.updateBoundData = function (gridName) {
    if ($('#' + gridName).length !== 0) {
      $('#' + gridName).jqxGrid('updatebounddata', 'data');
      var sortinformation = $('#' + gridName).jqxGrid('getsortinformation');
      if (sortinformation && sortinformation.sortcolumn && sortinformation.sortdirection) { // need to send sort manually because JQX does not consider sort if data source changes.( auto refresh)
        if (sortinformation.sortdirection.ascending) {
          $('#' + gridName).jqxGrid('sortby', sortinformation.sortcolumn, 'ascending');
        }

        if (sortinformation.sortdirection.descending) {
          $('#' + gridName).jqxGrid('sortby', sortinformation.sortcolumn, 'descending');
        }
      }
    }
  };
  /**
   * common Method for initiating right click menu window.
   * @param event
   * @param contextMenu
   */
  this.initGridRightClickContextMenu = function (event, contextMenu) {
    if (event && contextMenu) {
      var scrollTop = $(window).scrollTop();
      var scrollLeft = $(window).scrollLeft();
      $('#' + event.currentTarget.id).jqxGrid('selectrow', event.args.rowindex);
      contextMenu.jqxMenu('open', parseInt(event.args.originalEvent.clientX) + 5 + scrollLeft, parseInt(event.args.originalEvent.clientY) + 5 + scrollTop);
    }
  };
  /**
   * common Method for executing a function for the context option .
   * @param event
   * @param ctxSourceName
   * @param contextSourceObj
   */
  this.executeContextMenuClick = function (event, ctxSourceName, contextSourceObj) {
    var contextMenuSource = contextSourceObj[ctxSourceName];
    for (var i = 0; i < contextMenuSource.length; i++) {
      if (contextMenuSource[i].label === event.args.innerText) {
        contextMenuSource[i].execute(contextMenuSource[i].reportName);
      }
    }
  };
  this.formatReportDateTime = function (_date, _time, formatType) {
    var splitedTime = _time.split(':');
    if (_date.indexOf('T') !== -1) {
      return $filter('date')(new Date(_date), 'yyyy/MM/dd/') + splitedTime[0] + ':' + splitedTime[1] + ':' + splitedTime[2];
    }

    var splitedDate = _date.split('/');
    splitedTime[2] = splitedTime[2] ? splitedTime[2] : '00';
    if (formatType) {
      return splitedDate[2] + formatType + splitedDate[1] + formatType + splitedDate[0] + 'T' +
        splitedTime[0] + ':' + splitedTime[1] + ':' + splitedTime[2];
    }
    return splitedDate[2] + '/' + splitedDate[1] + '/' + splitedDate[0] + '/' +
      splitedTime[0] + ':' + splitedTime[1] + ':' + splitedTime[2];
  };

  this.getExportURL = function (reportName, exportOption, type, selectedID, reportOption, dateFrom, dateTo, emailList, reportSettings) {
    var baseurl = '';
    var additionalReportOptions = {
      _reportOptionFor: '',
      _reportOtptionSqlType: '',
      _reportOptions: ''
    };

    var isMutioptionReportFound = false;
    if (reportSettings) {
      for (var i in reportSettings) {
        if (reportSettings[i]._reportName === reportName) {
          if (reportSettings[i]._isReportOptionMultiSelect) {
            isMutioptionReportFound = true;
            additionalReportOptions._reportOptionFor = reportSettings[i]._multiSelectPropertyName;
            var multiSelectedComboboxOption = [];
            if (reportName === 'DriverWorkingHours') {
              multiSelectedComboboxOption = $('#' + reportSettings[i]._comboID).jqxComboBox('getCheckedItems');
              if (multiSelectedComboboxOption.length > 0 && multiSelectedComboboxOption[0].value === 'selectAll') {
                multiSelectedComboboxOption.shift();
              }
            } else {
              multiSelectedComboboxOption = $('#' + reportSettings[i]._comboID).jqxComboBox('getSelectedItems');
            }

            var optionsArray = [];
            for (var j in multiSelectedComboboxOption) {
              optionsArray.push(multiSelectedComboboxOption[j].value);
            }
            if (multiSelectedComboboxOption.length > 1) {
              additionalReportOptions._reportOtptionSqlType = 'in';

            } else {
              additionalReportOptions._reportOtptionSqlType = 'where';
            }
            additionalReportOptions._reportOptions = optionsArray;
            //console.log(additionalReportOptions);
          }
          break;
        }
      }
    }

    switch (exportOption) {
      case 'CSV':
        baseurl += '&page=report.show&page_cmd=rptsel&' + type + '=' + selectedID + '&r_report=' + reportName + '&r_option=' + reportOption + '&date_fr=' + dateFrom + '&' +
          'date_to=' + dateTo + '&date_tz=' + accountSettings.timeZone + '&r_format=csv' + '&locale=' + languageService.getLanguageSettings().language;
        break;
      case 'XLS':
        // bug 88893 - added locale param to xls reports
        baseurl += '&page=report.show&page_cmd=rptsel&' + type + '=' + selectedID + '&r_report=' + reportName + '&r_option=' + reportOption + '&date_fr=' + dateFrom + '&' +
          'date_to=' + dateTo + '&date_tz=' + accountSettings.timeZone + '&r_format=xls' + '&locale=' + languageService.getLanguageSettings().language;
        break;
      case 'EMail':
        baseurl += '&page=report.show&page_cmd=rptsel&' + type + '=' + selectedID + '&r_report=' + reportName + '&r_option=' + reportOption + '&date_fr=' + dateFrom + '&' +
          'date_to=' + dateTo + '&date_tz=' + accountSettings.timeZone + '&r_format=ehtml&r_emailAddr=' + emailList + '&locale=' + languageService.getLanguageSettings().language;
        break;
    }
    if (isMutioptionReportFound) {
      baseurl += '&_reportOptionFor=' + additionalReportOptions._reportOptionFor + '&_reportOtptionSqlType=' + additionalReportOptions._reportOtptionSqlType + '&_reportOptions=' + additionalReportOptions._reportOptions;
    }
    return baseurl;
  };

  this.getReportMap = function (baseurl, reportName, type, selectedID, reportOption, dateFrom, dateTo) {
    return baseurl + mainUrlDetails + '&page=report.show&page_cmd=rptsel&' + type.toLoawerCaseAt(0) + '=' + selectedID + '&r_report=' + reportName + '&r_option=' + reportOption + '&date_fr=' + dateFrom + '&date_to=' + dateTo + '&date_tz=' + accountSettings.timeZone + '&fmt=map&required_session=false&geoZoneAccount=true';
  };

  this.getVehicleListFilterByGroupId = function (groupId) {
    return crudService.get('overview/vehiclelist', groupId).then(function (vehicleList) {

      return vehicleList.sort(function (a, b) {
        return _sortCompare(a.description, b.description, true);
      });

    });
  };

  this.setLastLocatioWidgetData = function (latstLocationSelection) {
    _lastLocationWidgetData = latstLocationSelection;
  };
  this.getDriverDashboardLastSelectedRowData = function () {
    return _driverDashboardWidgetData;
  };
  this.setDriverDashboardLastSelectedRowData = function (rowData) {
    _driverDashboardWidgetData = rowData;
  };
  this.getsetLastLocatioWidgetData = function () {
    return _lastLocationWidgetData;
  };

  this.getLastSelectedGroup = function () {
    return _lastSelectedGroup;
  };

  this.setLastSelectedGroup = function (group) {
    _lastSelectedGroup = group;
  };

  this.init = function () {
    $http.defaults.headers.common['X-BetoTrack-Locale'] = languageService.getLanguageSettings().language;
  };


  this.getFleetSettings = function () {
    var fleetSettings = {
      messageUpdatedTime: '',
      msgTimeStamp: [],
      readMessages: [],
      readNotification: []
    };
    var fleetSettingsInStore = localStorageService.get('fleetSettings.' + loginID.Account + '.' + loginID.username);
    if (fleetSettingsInStore !== null) {
      return fleetSettingsInStore;
    }
    return fleetSettings;
  };

  this.setMessageLocalStorgaeProp = function (mesageUpdatedTime, messageTimestampList) {
    var fleetSettingsInStore = this.getFleetSettings();
    fleetSettingsInStore.messageUpdatedTime = mesageUpdatedTime;
    fleetSettingsInStore.msgTimeStamp = messageTimestampList;
    this.saveFleetSettings(fleetSettingsInStore);
  };
  this.setReadMessagesToLocalStorage = function (readMessagesList) {
    var fleetSettingsInStore = this.getFleetSettings();
    fleetSettingsInStore.readMessages = readMessagesList;
    this.saveFleetSettings(fleetSettingsInStore);
  };
  this.setReadNotification = function (notificaionTimeStamp) {
    var fleetSettingsInStore = this.getFleetSettings();
    fleetSettingsInStore.readNotification.push(notificaionTimeStamp);
    fleetSettingsInStore.readNotification = removeNotificationOlderThanCrrentDay(fleetSettingsInStore.readNotification);
    this.saveFleetSettings(fleetSettingsInStore);
  };
  this.getReadMessageFromLocalStorage = function () {
    var fleetSettingsInStore = this.getFleetSettings();
    return fleetSettingsInStore.readMessages || [];
  };
  this.saveFleetSettings = function (newFleetSettings) {
    newFleetSettings.msgTimeStamp = removeOlderThan3ayTimestamps(newFleetSettings.msgTimeStamp);
    newFleetSettings.readMessages = removeOlderThan3ayTimestamps(newFleetSettings.readMessages);
    localStorageService.set('fleetSettings.' + loginID.Account + '.' + loginID.username, newFleetSettings);
  };

  function removeOlderThan3ayTimestamps(timeStampArray) {
    return _removeOlderTimeStampValues(timeStampArray, 3);
  }

  function removeNotificationOlderThanCrrentDay(readNotificationTimeStampArray) {
    return _removeOlderTimeStampValues(readNotificationTimeStampArray, 1);
  }

  function _removeOlderTimeStampValues(timeStampArray, noOfDays) {
    var _tmpTimeStampArry = [];
    if (timeStampArray && timeStampArray.length > 0) {
      for (var i = 0; i < timeStampArray.length; i++) {
        var _tmpTstampDate = new Date(Number(timeStampArray[i]) * 1000);
        var _tmpCompareDate = new Date();
        _tmpCompareDate.setDate(_tmpCompareDate.getDate() - noOfDays);
        if (_tmpTstampDate >= _tmpCompareDate) {
          _tmpTimeStampArry.push(timeStampArray[i]);
        }
      }
    }
    return _tmpTimeStampArry;
  }

  this.getNotifications = function () {
    return notificationProperties;
  };


  this.saveDriverMessage = function (deviceID, message, messageTypdescription, isGroup) {
    var _msgType = getMessageTypeNumber(messageTypdescription);
    var deviceMessage = {
      deviceID: deviceID,
      message: message,
      messageType: _msgType,
    };

    var url = '/messaging?isGroupMessage=' + (isGroup ? 'true' : 'false');
    return crudService.post(url, deviceMessage);
  };


  this.getDriverMessages = function (exsistingList, chatDeriveId) {
    var _tmpfrmDate = new Date();
    _tmpfrmDate.setDate(_tmpfrmDate.getDate() - 3);
    var fleetLocalStorageSettings = this.getFleetSettings();
    var timeFrom = fleetLocalStorageSettings.messageUpdatedTime ? $filter('date')(new Date(), 'yyyy/MM/dd/') + '00:00:00' : $filter('date')(_tmpfrmDate, 'yyyy/MM/dd/') + '00:00:00';
    var timeTo = $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');
    var requestParam = {
      statusCode: '',
      deviceid: chatDeriveId,
      dataRefresh: false,
      timeTo: timeTo,
      timeFrom: timeFrom,
      reportName: 'DriverMessageDetail'
    };


    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('messaging', 'devicemessages', param).then(function (messageList) {
      return _filterMessage(messageList,exsistingList);

    }, function (response) {
      errorHandlingService.handleForCommonResponse(response);
    });

  };

  this.getGroupMessages = function (existingGroupMessages, chatGroupId) {
    var _tmpfrmDate = new Date();
    _tmpfrmDate.setDate(_tmpfrmDate.getDate() - 3);
    var fleetLocalStorageSettings = this.getFleetSettings();
    var timeFrom = fleetLocalStorageSettings.messageUpdatedTime ?
      $filter('date')(new Date(), 'yyyy/MM/dd/') + '00:00:00' :
      $filter('date')(_tmpfrmDate, 'yyyy/MM/dd/') + '00:00:00';
    var timeTo = $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');

    var requestParam = {
      statusCode: '',
      groupId: chatGroupId,
      dataRefresh: false,
      timeTo: timeTo,
      timeFrom: timeFrom,
      reportName: 'GroupMessageDetail'
    };

    var param = {
      'filter': JSON.stringify(requestParam)
    };

    return crudService.customGET('messaging', 'groupmessages/' + chatGroupId, param).then(function (response) {
      if (response && response.groupConversations) {
        return response;
      } else if (response && Array.isArray(response)) {
        return { groupConversations: response };
      } else {
        console.log('Group messages response:', response);
        return { groupConversations: [] };
      }
    }, function (response) {
      console.error('Error fetching group messages:', response);
      errorHandlingService.handleForCommonResponse(response);
      return { groupConversations: [] };
    });
  };

  // This api should be used under Instant messaging
  this.getInstantDriverMessages = function (exsistingList, exsitingNotificationList, mqMessage, isFromMq) {
    var fleetLocalStorageSettings = this.getFleetSettings();
    var timeTo = $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');

    var _filteredData = _filterMessgae(mqMessage, fleetLocalStorageSettings, timeTo, exsistingList, exsitingNotificationList, isFromMq);
    var _filteredGroupData = _filterGroupMessage(mqMessage, exsitingNotificationList);
    var deferred = $q.defer();
    deferred.resolve(_filteredData);
    deferred.resolve(_filteredGroupData);
    return deferred.promise;
  };

  function _filterMessage(messageList, exsistingList) {
    //Check which messages are unread
    var messages = messageList.driverDevices;
    var isAckMessage = false;
    var mesgUnreadCount = 0;

    if(exsistingList !== undefined) {
      for (var i = 0; i < messages.length; i++) {
            // check if exsiting  list already contains this new message
            var _isExsistingListAlreadyContainsMsg = false;
            for (var l = 0; l < exsistingList.length; l++) {
              if (exsistingList[l].deviceID === messages[i].deviceID && exsistingList[l].lastMessageTimeStamp === messages[i].lastMessageTimeStamp) {
                _isExsistingListAlreadyContainsMsg = true;
                break;
              }
            }
            if (!_isExsistingListAlreadyContainsMsg) {
              isAckMessage = messages[i].lastMessage.beginsWith('{');
              if (!isAckMessage) {
                mesgUnreadCount++;
              }
            }
      }
    }
    //Bugfix 104164: Ensure New Message notification does not always popup on refresh
    //This is the total unread messages since the last page refresh / data refresh
    //Not the same as the total unread messages received from fleetapi backend
    messageList.unreadMessages = mesgUnreadCount;
    return messageList;
  }

  function _filterGroupMessage(messageList, existingGroupList) {
    var groups = messageList.driverDevices || [];
    var msgUnreadCount = 0;
    if (existingGroupList !== undefined && existingGroupList.length > 0) {
      for (var i = 0; i < groups.length; i++) {
        var groupFound = false;
        for (var j = 0; j < existingGroupList.length; j++) {
          if (existingGroupList[j].groupId === groups[i].deviceID) {
            groupFound = true;
            existingGroupList[j].unreadCount = groups[i].unreadMessageCount || 0;
            if (groups[i].messages && groups[i].messages.length > 0) {
              existingGroupList[j].latestMessagePreview = groups[i].messages[0].drivermessage || '';
            }
            break;
          }
        }
        if (!groupFound && groups[i].unreadMessageCount > 0) {
          msgUnreadCount += groups[i].unreadMessageCount;
        }
      }
    } else {
      for (var k = 0; k < groups.length; k++) {
        if (groups[k].unreadMessageCount > 0) {
          msgUnreadCount += groups[k].unreadMessageCount;
        }
      }
    }
    messageList.unreadMessages = msgUnreadCount;
    messageList.totalUnreadMessages = msgUnreadCount;
    return messageList;
  }

  function _filterMessgae(messageList, fleetLocalStorageSettings, timeTo, exsistingList, exsitingNotificationList, isFromMq) {
    var messages = messageList ? messageList.reverse() : messageList;
    var driverMessageList = [];
    var messageTimeStampArray = fleetLocalStorageSettings.msgTimeStamp;
    var _tmpMessageTimeStampArry = [];
    var _tmpFlag = false;
    var isAckMessage = false;
    var mesgUnreadCount = 0;
    for (var i = 0; i < messages.length; i++) {
      messages[i].statuscode = messages[i].statuscode === 57777 ? '0xE1B1' : messages[i].statuscode;
      if (messages[i].statuscode === '0xE1B1') {
        if (messageTimeStampArray.length > 0 && !isFromMq) {
          for (var j = 0; j < messageTimeStampArray.length; j++) {
            if (messageTimeStampArray[j] === messages[i].messagetimestamp) {
              _tmpFlag = true;
            }
          }
        }
        var readLocalStorageMessages = that.getReadMessageFromLocalStorage();
        var isRead = false;
        for (var k = 0; k < readLocalStorageMessages.length; k++) {
          if (messages[i].messagetimestamp === readLocalStorageMessages[k]) {
            isRead = true;
            break;
          }
        }

        if (!_tmpFlag && !isRead || _tmpFlag && !isRead) {
          messages[i]._dateTimeDescription = ' ' + $filter('date')(new Date(Number(messages[i].messagetimestamp) * 1000), 'dd.MM.yy HH:mm');
          messages[i]._timeShortDes = ' ' + $filter('date')(new Date(Number(messages[i].messagetimestamp) * 1000), 'EEE  HH:mm');
          messages[i]._isMsgRead = isRead;
          // check if exsiting  list already contains this new message
          var _isExsistingListAlreadyContainsMsg = false;
          for (var l = 0; l < exsistingList.length; l++) {
            if (exsistingList[l].messagetimestamp === messages[i].messagetimestamp) {
              _isExsistingListAlreadyContainsMsg = true;
              break;
            }
          }
          if (!_isExsistingListAlreadyContainsMsg) {
            isAckMessage = messages[i].drivermessage.beginsWith('{');
            if (!isAckMessage) {
              mesgUnreadCount++;
            }
            driverMessageList.push(messages[i]);
          }
          if (!_tmpFlag) {
            _tmpMessageTimeStampArry.push(messages[i].messagetimestamp);
          }
        }
      }

    }
    driverMessageProperties.unreadMessages = mesgUnreadCount;
    driverMessageProperties.driverMessageList = driverMessageList.concat(exsistingList);
    for (var m = 0; m < _tmpMessageTimeStampArry.length; m++) {
      messageTimeStampArray.push(_tmpMessageTimeStampArry[m]);
    }
    that.setMessageLocalStorgaeProp(timeTo, messageTimeStampArray);
    driverMessageProperties._tmpRefreshCheck = false;
    return driverMessageProperties;
  }

  this.getMessageHistoryByDevice = function (deviceID, timeFrom, timeTo) {
    var requestParam = {
      dataRefresh: false,
      timeTo: timeTo,
      timeFrom: timeFrom,
      reportName: 'DriverMessageDetail'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('messaging', 'devicemessages/' + deviceID, param);
  };

  function getMessageTypeNumber(typeDescription) {
    switch (typeDescription) {
      case 'Yes/No':
        return 2;
      case 'Ok':
        return 1;
      case 'Text':
        return 3;
    }
  }

  this.getAvailableGroups = function () {
  return crudService.get('messaging/groups/availableGroups').then(function (availableGroups) {
    if (availableGroups && Array.isArray(availableGroups)) {
      availableGroups.forEach(function(group) {
        if (group.groupMembers && Array.isArray(group.groupMembers)) {
          group.groupMembers = group.groupMembers.map(function(member) {
            // If member is already an object with deviceId, keep it
            if (typeof member === 'object' && member !== null && (member.deviceId || member.deviceID)) {
              return member;
            }
            // If member is a string (deviceId), keep it as is
            return member;
          });
        }
      });
    }
    return availableGroups;
  }, function (response) {
    console.error('Error fetching available groups:', response);
    errorHandlingService.handleForCommonResponse(response);
    return [];
  });
};

  this.getGeneralSettings = function () {
    var _generalSettings = localStorageService.get('fleetSettings.generalSettings');
    if (_generalSettings) {
      return _generalSettings;
    }
    return gerneralSettings;
  };
  this.saveGeneralSettings = function (generalSettings) {
    localStorageService.set('fleetSettings.generalSettings', generalSettings);
  };

  /**
   * Method returns vehicle based dashboard widget names used in Appending Vehicle ID to the widget title.
   * @returns {string[]}
   */
  this.getVehicleBasedWidgetNameArray = function () {
    return [{
      name: 'vehicleMapWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.deviceMap.deviceMapTitle'
    }, {
      name: 'vehicleDetailsWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.vehicleDetails.vehicleDetailsTitle'
    }, {
      name: 'vehicleListWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.vehicleList.vehicleListTitle'
    }, {
      name: 'TempMonitoringWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.tempMonitoringWidget.title'
    }, {
      name: 'DriverWrkHrsWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.driverWorkingHours.driverWrkHoursList'
    }, {
      name: 'DriverWrkHrsSVGWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.driverWhrkHrsSVG.title'
    }, {
      name: 'vehiclesListWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.vehiclesListWidget.title'
    }, {
      name: 'vehicleStatusWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.vehicleStatusWidget.title'
    }, {
      name: 'digitalOutputsWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.digitalOutputsWidget.title'
    }, {
      name: 'pendingCommandsWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.pendingCommandsWidget.title'
    }, {
      name: 'FMSVehicleWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.fmsVehicle.vehicleList'
    }, {
      name: 'DriverDigitalTachoStatusWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.driverDigitalTachoStatus.driverDigitalTachoStatusTitle'
    }, {
      name: 'tachoDownloadStatusWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.tachoDownloadStatus.title'
    }];
  };

  /**
   * Method returns Fleet based dashboard widget names used in Appending Vehicle ID to the widget title.
   * @returns {string[]}
   */
  this.getFleetBasedWidgetNameArray = function () {
    return [{
      name: 'fleetMapWidget',
      titleTranslationKey: 'dashBoard.fleetManagement.fleetMap.fleetMapTitle'
    }];
  };

  this._loopWidgetsInDashboard = function (dashBoardModel, titleAppendTypeArray, selectedID) {

    for (var a = 0; a < titleAppendTypeArray.length; a++) {
      var _widget = dashboardService.getDashboardWidget(dashBoardModel, titleAppendTypeArray[a].name);
      var locales = ['en', 'de', 'nl'];
      var isFound = false;

      if (_widget) {
        var titleSplitArray = _widget.title.split('/')[0].trim();
        for (var index in locales) {
          if (titleSplitArray === $translate.instant(titleAppendTypeArray[a].titleTranslationKey, null, null, locales[index])) {
            isFound = true;
            break;
          }
        }
        if (isFound) {// is default translation  found
          _widget.title = $translate.instant(titleAppendTypeArray[a].titleTranslationKey);
        } else {
          _widget.title = titleSplitArray;
        }
      }
      if (_widget && selectedID !== null) {
        _widget.title += ' / ' + selectedID;
      }
    }
  };

  this.getNotificationListCurentDay = function () {
    var timeFrom = $filter('date')(new Date(), 'yyyy/MM/dd/') + '00:00:00';
    var timeTo = $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');
    var requestParam = {
      vehicleGroup: 'all',
      timeTo: timeTo,
      timeFrom: timeFrom,
      reportName: 'NotifyQueueDetail_Group'
    };
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return crudService.customGET('notifications', '', param);
  };

  this.getJqxLineChartSettings = function () {
    var settings = {
      title: '',
      description: '',
      enableAnimations: true,
      enableCrosshairs: true,
      crosshairsDashStyle: '1,1',
      crosshairsColor: '#0000FF',
      showLegend: true,
      padding: { left: 15, top: 5, right: 30, bottom: 5 },
      titlePadding: { left: 90, top: 0, right: 0, bottom: 10 },
      source: [],
      xAxis: {},
      colorScheme: 'scheme01',
      seriesGroups: []
    };

    return settings;
  };
  /**
   * Util Method for executing an Iframe document method .
   * @param method
   * @param iframeName
   */
  this.iframePostMessage = function (method, iframeName) {
    if (document.getElementById(iframeName) !== null) {
      var receiver = document.getElementById(iframeName).contentWindow;
      var postMessageObj = { method: 'window.' + method, messageOrigin: $window.location.origin };
      try {
        receiver.postMessage(postMessageObj, gtsServerSettings.qualifiedServerURL);
      } catch (err) {
        console.log(err.message);// could throw an exception if iframe not initiazed or takes too much time
      }
    }
  };
  /**

   * Util method for Start and stop auto refresh functionality.
   * if 'hasVehicleMap' start/stop iframe map auto update.
   * if 'hasFleetMap' tart/stop iframe map auto update.
   * @param $scope
   * @param hasVehicleMap
   * @param hasFleetMap
   * @param customFunction
   * @param arg1, arg2, arg3 : customFunction arguments arg1 - arg/combobox  arg2- data refresh,  arg3 arg/combobox
   * @returns {Function}
   */
  this.getRefreshStartStopfunction = function ($scope, hasVehicleMap, hasFleetMap, customFunction, arg1, arg2, arg3, event) {
    return function () {
      if (!$scope.isTimerStated) {
        if (event) {
          $scope.isStopedByUser = false;
        }
        $scope.counter = 60;
        var _tmpArg1 = '';
        var _tmpArg3 = '';
        if (arg1 && typeof arg1 === 'string' && arg1.indexOf('ComboBox') !== -1) {
          _tmpArg1 = $('#' + arg1).jqxComboBox('getSelectedItem').value || '';
        } else {
          _tmpArg1 = arg1;
        }
        if (arg3 && typeof arg3 === 'string' && arg3.indexOf('ComboBox') !== -1) {
          _tmpArg3 = $('#' + arg3).jqxComboBox('getSelectedItem').value || '';
        } else {
          _tmpArg3 = arg3;
        }
        customFunction(_tmpArg1, arg2, _tmpArg3);
        // only send autoUpdate of map if the chatWindow is not opened
        if ($('.chat-window-container').length === 0) {

          if (hasVehicleMap) {
            that.iframePostMessage('startAutoUpdateMapTimer()', 'vehicleMap');
          }
          if (hasFleetMap) {
            that.iframePostMessage('startAutoUpdateMapTimer()', 'fleetMap');
          }
        }
      } else {
        $scope.stop();
        if (event) {
          $scope.isStopedByUser = true;
        }
        $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.startAutoUpdate');
        $scope.isTimerStated = !$scope.isTimerStated;
        if (hasVehicleMap) {
          that.iframePostMessage('stopAutoUpdateMapTimer()', 'vehicleMap');
        }
        if (hasFleetMap) {
          that.iframePostMessage('stopAutoUpdateMapTimer()', 'fleetMap');
        }
      }
    };
  };
  /*
   * Most of the Utility functions used in BetoTrack can be found below.
   *
   * */

  this.getDateRangePickerSettings = function (customEvent, dateRangeType = this.dateRange.LONG) {
    var options = {
      showDropdowns: true,
      showWeekNumbers: true,
      timePicker: true,
      timePickerIncrement: 1,
      autoUpdateInput: true,
      timePicker24Hour: true,
      autoApply: true,
      linkedCalendars: false,
      dateLimit: {},
      clearLabel: $translate.instant('dateRangePicker.locale.clearLabel'),
      locale: {
        format: 'YYYY/MM/DD HH:mm:ss',
        applyLabel: $translate.instant('dateRangePicker.locale.applyLabel'),
        cancelLabel: $translate.instant('dateRangePicker.locale.cancelLabel'),
        fromLabel: $translate.instant('dateRangePicker.locale.fromLabel'),
        toLabel: $translate.instant('dateRangePicker.locale.toLabel'),
        customRangeLabel: $translate.instant('dateRangePicker.locale.customRangeLabel'),
        weekLabel: $translate.instant('dateRangePicker.locale.weekLabel'),
        firstDay: 1,
        daysOfWeek: [
          $translate.instant('dateRangePicker.locale.daysOfWeek.Sunday'),
          $translate.instant('dateRangePicker.locale.daysOfWeek.Monday'),
          $translate.instant('dateRangePicker.locale.daysOfWeek.Tuesday'),
          $translate.instant('dateRangePicker.locale.daysOfWeek.Wednesday'),
          $translate.instant('dateRangePicker.locale.daysOfWeek.Thursday'),
          $translate.instant('dateRangePicker.locale.daysOfWeek.Friday'),
          $translate.instant('dateRangePicker.locale.daysOfWeek.Saturday')
        ],
        monthNames: [
          $translate.instant('dateRangePicker.locale.monthNames.January'),
          $translate.instant('dateRangePicker.locale.monthNames.February'),
          $translate.instant('dateRangePicker.locale.monthNames.March'),
          $translate.instant('dateRangePicker.locale.monthNames.April'),
          $translate.instant('dateRangePicker.locale.monthNames.May'),
          $translate.instant('dateRangePicker.locale.monthNames.June'),
          $translate.instant('dateRangePicker.locale.monthNames.July'),
          $translate.instant('dateRangePicker.locale.monthNames.August'),
          $translate.instant('dateRangePicker.locale.monthNames.September'),
          $translate.instant('dateRangePicker.locale.monthNames.October'),
          $translate.instant('dateRangePicker.locale.monthNames.November'),
          $translate.instant('dateRangePicker.locale.monthNames.December')
        ]
      },
      ranges: {}
    };

    that.setDateRangePickerCustomOptions(options, dateRangeType);

    options.eventHandlers = {
      'show.daterangepicker': function () {
        if (that.getDateRangePickerInitializedDate().isBefore(moment(), 'minute')) {
          $rootScope.$broadcast('date-range-internalDate-old', {});
        }
      }
    };
    if (customEvent) {
      options.eventHandlers = _.extend(options.eventHandlers, customEvent.eventHandlers);
    }
    return options;
  };

  this.setDateRangePickerInitializedDate = function (momentDate) {
    _dateRangePickerInitializedDate = momentDate;
  };
  this.getDateRangePickerInitializedDate = function () {
    return _dateRangePickerInitializedDate ? _dateRangePickerInitializedDate : moment();
  };
  this.getDateRangePickerRange = function (settings, reportName) {
    return this.dateRange[settings[reportName]];
  };

  this.setDateRangePickerCustomOptions = function (options, range = this.dateRange.LONG) {
    if (options === undefined) {
      return;
    }

    that.setDateRangePickerInitializedDate(moment());
    options.ranges = {};
    options.dateLimit = {};

    if (range === this.dateRange.SHORT) {
      options.ranges[$translate.instant('dateRangePicker.ranges.Standard')] = [moment().subtract(2, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Today')] = [moment().clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Yesterday')] = [moment().subtract(1, 'days').clone().startOf('day'), moment().subtract(1, 'days').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_hour')] = [moment().subtract(1, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_2_hours')] = [moment().subtract(2, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_4_hours')] = [moment().subtract(4, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_8_hours')] = [moment().subtract(8, 'hours').clone(), moment().clone()];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_24_hours')] = [moment().subtract(24, 'hours').clone(), moment().clone()];

      options.dateLimit.hours = 24;
    } else if (range === this.dateRange.MID) {
      options.ranges[$translate.instant('dateRangePicker.ranges.Standard')] = [moment().clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Today')] = [moment().clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Yesterday')] = [moment().subtract(1, 'days').clone().startOf('day'), moment().subtract(1, 'days').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_2_days')] = [moment().subtract(2, 'days').clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_7_days')] = [moment().subtract(7, 'days').clone().startOf('day'), moment().clone().endOf('day')];

      options.dateLimit.days = 7;
    } else {
      options.ranges[$translate.instant('dateRangePicker.ranges.Standard')] = [moment().subtract(7, 'days').clone().startOf('day'), moment().add(7, 'days').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Today')] = [moment().clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Yesterday')] = [moment().subtract(1, 'days').clone().startOf('day'), moment().subtract(1, 'days').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_7_days')] = [moment().subtract(7, 'days').clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_30_days')] = [moment().subtract(30, 'days').clone().startOf('day'), moment().clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.This_month')] = [moment().startOf('month').clone().startOf('day'), moment().endOf('month').clone().endOf('day')];
      options.ranges[$translate.instant('dateRangePicker.ranges.Last_Month')] = [moment().subtract(1, 'months').startOf('month').clone().startOf('day'), moment().subtract(1, 'months').endOf('month').clone().endOf('day')];

      options.dateLimit = false;
    }

    return options.ranges;
  };

  this.getDateTime = function (type, format) {
    if (type === 'present' && format === 'yyyy/MM/dd/HH:mm:ss') {
      return $filter('date')(new Date(), 'yyyy/MM/dd/HH:mm:ss');
    }

    if (type === 'startOfDay' && format === 'yyyy/MM/dd/HH:mm:ss') {
      return $filter('date')(new Date(), 'yyyy/MM/dd/') + '00:00:00';
    }
    if (type === 'present' && format === 'yyyy-MM-ddTHH:mm:ss') {
      return $filter('date')(new Date(), 'yyyy-MM-ddTHH:mm:ss');
    }
    if (type === 'startOfDay' && format === 'yyyy-MM-ddTHH:mm:ss') {
      return $filter('date')(new Date(), 'yyyy-MM-dd') + 'T00:00:00';
    }
  };

  Number.prototype._isInt = function (n) {
    return n % 1 === 0;
  };
  Number.prototype._isFloat = function (n) {
    return Number(n) === n && n % 1 !== 0;
  };

  String.prototype._appendBefore = function (padString, length) {
    var str = this;
    while (str.length < length) {
      str = padString + str;
    }
    return str;
  };

  String.prototype.beginsWith = function (string) {
    return (this.indexOf(string) === 0);
  };

  String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
  };

  String.prototype.replaceAt = function (index, character) {
    return this.substr(0, index) + character + this.substr(index + character.length);
  };

  String.prototype.toLoawerCaseAt = function (index) {
    return this.charAt(index).toLocaleLowerCase() + this.slice(1);
  };


  /**
   *  get cache vehicle value.
   * @param vehicleList
   * @returns {string}
   */
  this.getCachedVehicleGroup = function (vehicleList) {
    var loginid = AuthenticationService.GetLoginID();
    var cachedGroup = localStorageService.get('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username);
    //check whether the cached group is in list
    var isExist = false;
    for (var i = 0; i < vehicleList.length; i++) {
      if (cachedGroup === vehicleList[i].groupID) {
        isExist = true;
        break;
      }
    }
    if (cachedGroup && isExist) {
      return cachedGroup;
    } else {
      localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, vehicleList[0].groupID);
      return vehicleList[0].groupID;
    }
  };


  this.setDataToLocalStorage = function (key, value) {
    var loginid = AuthenticationService.GetLoginID();
    localStorageService.set(key + '.' + loginid.Account + '.' + loginid.username, value);
  };

  this.getDataFromLocalStorage = function (key) {
    var loginid = AuthenticationService.GetLoginID();
    return localStorageService.get(key + '.' + loginid.Account + '.' + loginid.username);
  };


  // method for gridSettings
  this.getUserSettings = function () {
    return that.getGtsLocalStorageSettings();
  };

  this.saveUserSettings = function (settings) {
    return that.saveGtsUserSettings(settings);
  };

  this.removeGridStateStorage = function (gridSettingId) {
    $window.localStorage.removeItem('jqxGrid' + gridSettingId);
  };

  //end gridSettings

  this.copyToClipboard = function (text) {
    var body = angular.element($window.document.body);
    var textarea = angular.element('<textarea>/');
    textarea.css({
      position: 'fixed',
      opacity: '0'
    });
    textarea.val(text);
    body.append(textarea);
    textarea[0].select();

    try {
      var successful = document.execCommand('copy');
      if (!successful) {
        throw successful;
      }
    } catch (err) {
      console.log('failed to copy', text);
    }
    textarea.remove();

  };
  this.getCustomSortFunction = function (gridName, source) {
    return function (column, direction) {
      var sortdata = [];

      if (direction === 'ascending' || direction === 'asc' || direction && direction.ascending) {
        direction = true;
      }
      if (direction === 'descending' || direction === 'desc' || direction && direction.descending) {
        direction = false;
      }

      if (direction !== null) {
        for (var i = 0; i < source.localdata.length; i++) {
          sortdata.push(source.localdata[i]);
        }
      }
      else {
        sortdata = source.localdata;
      }

      var tmpToString = Object.prototype.toString;
      Object.prototype.toString = (typeof column === 'function') ? column : function () {
        return this[column];
      };

      var result;
      if(source.datafields && column) {
        result = source.datafields.find(o=> o.name === column);
      }

      if(column === 'devicedesc' && direction !== null) {
        sortdata.sort(compareVehicleDescription(direction));
      } else if(column === 'drumrotation' && direction !== null) {
        sortdata.sort(comparePercent(direction));
      } else if (result && result.type === 'number' && direction !== null) {
        sortdata.sort(compareFloat(direction));
      } else if (direction !== null) {
        sortdata.sort(compare(direction));
      }

      source.localdata = sortdata;
      $('#' + gridName).jqxGrid('updatebounddata', 'sort');
      Object.prototype.toString = tmpToString;
    };
  };

  //SCL-10332 Sort vehicle description by numbers, special characters and then alphabetically
  var compareVehicleDescription = function (direction) {
    return function (value1, value2) {
      return _sortCompareVehicleDesc(value1.devicedesc, value2.devicedesc, direction);
    };
  };

  function _sortCompareVehicleDesc(value1, value2, direction) {
    value1 = String(value1).toLowerCase();
    value2 = String(value2).toLowerCase();
    var timeEmptyStringformat = '---';

    if (value1 === '' || timeEmptyStringformat === value1.trim()) {
      return 1;
    } else if (value2 === '' || timeEmptyStringformat === value2.trim()) {
      return -1;
    }

    var startsWithDigit1 = /^\d/.test(value1);
    var startsWithDigit2 = /^\d/.test(value2);
    var startsWithSpecial1 = /^[!@#$%^&*]/.test(value1);
    var startsWithSpecial2 = /^[!@#$%^&*]/.test(value2);

    var priority1 = startsWithDigit1 ? 1 : (startsWithSpecial1 ? 2 : 3);
    var priority2 = startsWithDigit2 ? 1 : (startsWithSpecial2 ? 2 : 3);

    // Groups always maintain priority order (1,2,3), only reverse within groups
    if (priority1 !== priority2) {
      return priority1 - priority2;
    }

    if (priority1 === 1 || priority2 === 1) {
      var num1 = parseInt(value1.match(/^\d+/)[0], 10);
      var num2 = parseInt(value2.match(/^\d+/)[0], 10);
      if (num1 !== num2) {
        return direction ? (num1 - num2) : (num2 - num1);
      }
      return direction ? (value1 > value2 ? 1 : -1) : (value1 > value2 ? -1 : 1);
    }

    if (priority1 === 2 || priority2 === 2) {
      var num1Match = value1.match(/\d+/);
      var num2Match = value2.match(/\d+/);

      if (num1Match && num2Match) {
        var numA = parseInt(num1Match[0], 10);
        var numB = parseInt(num2Match[0], 10);
        if (numA !== numB) {
          return direction ? (numA - numB) : (numB - numA);
        }
      }
      return direction ? (value1 > value2 ? 1 : -1) : (value1 > value2 ? -1 : 1);
    }
    return _sortCompare(value1, value2, direction);
  }

  this.getCustomReportSortFunction = function (gridName, source) {
    return function (column, direction) {
      var sortdata = [];
      var nonsortdata = [];

      if (direction === 'ascending' || direction === 'asc' || direction && direction.ascending) {
        direction = true;
      }
      if (direction === 'descending' || direction === 'desc' || direction && direction.descending) {
        direction = false;
      }

      if (direction !== null) {
        for (var i = 0; i < source.localdata.length; i++) {
          var item = source.localdata[i];
          var c = that.cellClassName(null, null, null, item);
          if (c === 'gridsummaryclass') {
            nonsortdata.push(item);
          } else {
            sortdata.push(source.localdata[i]);
          }
        }
      }
      else {
        sortdata = source.localdata;
      }

      var tmpToString = Object.prototype.toString;
      Object.prototype.toString = (typeof column === 'function') ? column : function () {
        return this[column];
      };

      var result;
      if(source.datafields && column) {
        result = source.datafields.find(o=> o.name === column);
      }

      if(column === 'drumrotation' && direction !== null) {
        sortdata.sort(comparePercent(direction));
      } else if (result && result.type === 'number' && direction !== null) {
        sortdata.sort(compareFloat(direction));
      } else if (direction !== null) {
        sortdata.sort(compare(direction));
      }

      //Now add the non sort data
      for (var x = 0; x < nonsortdata.length; x++) {
        sortdata.push(nonsortdata[x]);
      }
      source.localdata = sortdata;
      $('#' + gridName).jqxGrid('updatebounddata', 'sort');
      Object.prototype.toString = tmpToString;
    };

  };

  var comparePercent = function (direction) {
    return function (value1, value2) {
      var value1Percent = value1.drumrotation / value1.drumrotationmax;
      var value2Percent = value2.drumrotation / value2.drumrotationmax;
      if(value1Percent === value2Percent) {
        return 0;
      }
      if(direction === true || direction.valueOf() === true) {
        return (value1Percent) >= (value2Percent) ? 1 : -1;
      } else if(direction === false|| direction.valueOf() === false) {
        return (value1Percent) <= (value2Percent) ? 1 : -1;
      }
    };
  };

  var compareFloat = function (direction) {
    return function (value1, value2) {
      if (value1 === value2) {
        return 0;
      }
      if(direction === true || direction.valueOf() === true) {
        return (value1) >= (value2) ? 1 : -1;
      } else if(direction === false|| direction.valueOf() === false) {
        return (value1) <= (value2) ? 1 : -1;
      }
    };
  };

  /**
   * This compare functon used under the JQX Grid custom Sorting ( JQX does not properly sort alpha numerical values which is type of (beton 07, beton 09, beton 43),
   * Bug 72967 - When sorting the grid by column Device Name with 0 are not sorted correct
   * @param value1
   * @param value2
   * @returns {number}
   */

  var compare = function (direction) {
    return function (value1, value2) {
      return _sortCompare(value1, value2, direction);
    };
  };

  function _sortCompare(value1, value2, direction) {
    value1 = String(value1).toLowerCase();
    value2 = String(value2).toLowerCase();
    var timeEmptyStringformat = '---';
    if (value1 === '' || timeEmptyStringformat === value1.trim()) {
      return 1;
    } else if (value2 === '' || timeEmptyStringformat === value2.trim()) {
      return -1;
    }

    var dateFormat = getDateFormat(value1) || getDateFormat(value2); // check any of the given value is  date
    // date format identified use moment to  comare
    if (dateFormat) {
      if (direction) {
        return moment(value1, dateFormat) - moment(value2, dateFormat);
      } else {
        return moment(value2, dateFormat) - moment(value1, dateFormat);
      }
    }

    var reA = /[^a-zA-Z]/g; // only characters
    var reN = /[^0-9]/g; // only numbers
    var regExForCharsAfterNumber = /\d*(.+[^a-zA-Z]+)/;
    var isval1HascharAfterNumber = value1.replace(regExForCharsAfterNumber, ''); // select characters after number
    var isval2HascharAfterNumber = value2.replace(regExForCharsAfterNumber, '');
    value1 = isval1HascharAfterNumber.length > 0 ? value1.replace(/(\d)\D+$/g, '$1') : value1; // replace character after number
    value2 = isval2HascharAfterNumber.length > 0 ? value2.replace(/(\d)\D+$/g, '$1') : value2; //replace character after number

    var aA = value1.replace(reA, '');
    var bA = value2.replace(reA, '');
    if (aA === bA) {
      var aN = parseInt(value1.replace(reN, ''), 10);
      var bN = parseInt(value2.replace(reN, ''), 10);
      if (direction) {
        if (aN === bN) {
          if (isval1HascharAfterNumber !== isval2HascharAfterNumber) {
            return isval1HascharAfterNumber > isval2HascharAfterNumber ? 1 : -1;
          }
          return 0;
        }
        return aN > bN ? 1 : -1;
      } else {
        if (aN === bN) {
          if (isval1HascharAfterNumber !== isval2HascharAfterNumber) {
            return isval1HascharAfterNumber > isval2HascharAfterNumber ? -1 : 1;
          }
          return 0;
        }
        return aN > bN ? -1 : 1;
      }
    } else {
      if (direction) {
        return aA > bA ? 1 : -1;
      } else {
        return aA > bA ? -1 : 1;
      }
    }
  }

  this.getOverviewGridPrefix = function () {
    return '_' + localStoragePrefix + '_';
  };

  /**
   * Checks viewport size and returns the Bootstrap  viewport equivalent name.
   *
   * @returns {string} returns the View Port String value
   */
  this.getViewPortName = function () {
    if ($(window).width() < 768) {
      return 'XS';
    }
    else if ($(window).width() >= 768 && $(window).width() <= 992) {
      return 'SM';
    }
    else if ($(window).width() > 992 && $(window).width() <= 1200) {
      return 'MD';
    }
    else {
      return 'LG';
    }
  };

  /**
   * Based on view port height the row  height is determined ( values are mock real height values  need to be finalized ).
   *
   * @returns {number}
   */
  this.getJqxGridRowHeight = function () {

    switch (that.getViewPortName()) {
      case 'XS':
        return 45;
      case 'SM':
        return 40;
      case 'MD':
        return 35;
      case 'LG':
        return 28;
      default:
        return 28;
    }
  };

  var TIME_STRING_FORMAT = {
    _1: '0d 00h 00m', // if days are present  time display in '12d 12h 12m' else '00h 12m'
    _2: '00h 00m'// if hours presnt '12h 12m' else '00h 12m'
  };

  this.getTimeStringFromMinutes = function getTimeStringFromMinutes(timeMinutes, format) {
    var hour, min;
    var resultString = '';
    if (format === TIME_STRING_FORMAT._1 || !format) {
      var day = Math.trunc(timeMinutes / 24 / 60);
      hour = Math.trunc(timeMinutes / 60 % 24);
      min = Math.trunc(timeMinutes % 60);

      if (day > 1 || day < 0 || day >= 1 && hour > 0) {
        day = day > 1 && day.toString().length === 1 ? '0' + day : day;
        resultString += day + 'd ';
      }
    } else if (format === TIME_STRING_FORMAT._2) {
      hour = Math.trunc(timeMinutes / 60);
      min = Math.trunc(timeMinutes % 60);
    }

    if (hour > 1 || hour < 0 || hour >= 1 && min > 0) {
      hour = hour > 1 && hour.toString().length === 1 ? '0' + hour : hour;
      resultString += hour + 'h ';
    } else {
      resultString += '00h ';
    }

    if (min > 1 || min < 0) {
      min = min > 1 && min.toString().length === 1 ? '0' + min : min;
      resultString += min + 'm';
    } else {
      resultString += '00m';
    }
    return resultString;
  };

  this.isLocalOrconfigVehicleGroupValid = function (vehicleGroupList, currentGroupId) {
    for (var i = 0; i < vehicleGroupList.length; i++) {
      if (vehicleGroupList[i].groupID === currentGroupId) {
        return true;
      }
    }
    return false;
  };

  this.getVehicleGridCommandList = function (deviceID) {
    return crudService.get('portalcommands/commandslist/' + deviceID);
  };

  this.sendCommand = function (deviceID, commandType, commandID) {
    var postObj = {
      deviceID: deviceID,
      deviceIds: [deviceID],
      commandType: commandType,
      commandID: commandID
    };
    return crudService.post('portalcommands/sendcommand', postObj);
  };
  /**
   * Checkes  given value and return identified Momoent date format .
   * Supported formates , code must be adopted for new formats
   * 'DD.MM.YYYY'
   * 'DD/MM/YYYY'
   * 'DD.MM.YYYY HH:mm:ss'
   * 'HH:mm:ss'
   * @param {*} value
   * @returns
   */

  function getDateFormat(value) {
    if (value.length === 10 && value.match(/(^\d{2}\.\d{2}\.\d{4}$)/g)) {
      return 'DD.MM.YYYY';
    }
    if (value.length === 10 && value.match(/(^\d{2}\/\d{2}\/\d{4}$)/g)) {
      return 'DD/MM/YYYY';
    }
    if (value.length === 19 && value.match(/^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2}):(\d{2})$/)) {
      return 'DD.MM.YYYY HH:mm:ss';
    }
    if (value.length === 19 && value.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/)) {
      return 'DD/MM/YYYY HH:mm:ss';
    }
    if (value.length === 8 && value.match(/^(\d{2}):(\d{2}):(\d{2})$/)) {
      return 'HH:mm:ss';
    }
  }

});




// WEBPACK FOOTER //
// ./.tmp/components/common/services/trackCommonService.js